import React from "react";
import SVG from "react-inlinesvg";

import { useIconResolver } from "./context/IconContext";
import { resolveUIIcon } from "./config/iconMapping";

// Core Icon component
const Icon = React.forwardRef(({
  size,
  symbol,
  className,
  style,
  ...rest
}, ref) => {
  const classes = [
    "ta-icon",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const resolveIcon = useIconResolver();
  let icon = "";

  if (symbol) {
    const uiIcon = resolveUIIcon(symbol);
    if (uiIcon !== null && uiIcon !== "") {
      icon = uiIcon;
    } else {
      icon = resolveIcon(symbol);
    }
  }

  return icon !== "" ? (
    <div ref={ref} className={classes} style={style} data-size={size || undefined} {...rest}>
      <SVG className={"ta-icon_content"} src={icon} />
    </div>
  ) : null;
});

export default Icon;
